import gql from "graphql-tag";

export const UPDATE = gql(`
mutation($applicationId: Int!
        $applicationVersion: Int!
        $componentId: Int!
        $componentDataSourceId: Int!
        $data: [DataUpdateInputType]!
        $transactionOperation:Boolean){
    dataMutation{
        updateData(applicationId:$applicationId,applicationVersion:$applicationVersion,componentId:$componentId,componentDataSourceId:$componentDataSourceId,data:$data,transactionOperation:$transactionOperation){
            id
            result
            error
        }
    }
}
`);
